export const ERROR_HAS_BEEN_REPORTED = "We're already looking into it.";
export const ERROR_OCCURRED = 'Sorry, an error occurred.';
export const ERROR_REQUEST_NOT_PROCESSED = "We couldn't process your request.";
